export enum ErrorType {
  ERROR = 'error',
  WARNING = 'warning',
}

export interface AiPromptBoxIssue {
  type: ErrorType;
  message: string;
  icon: string;
}